import script from "./LiveTranslationEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveTranslationEntry.vue?vue&type=script&setup=true&lang=js"

import "./LiveTranslationEntry.vue?vue&type=style&index=0&id=57d5cf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d5cf9c"]])

export default __exports__